// apps/frontend/src/services/referralService.ts
// Service parrainage

import apiClient from './apiClient';

export interface ReferralMilestone {
  signups: number;
  reached: boolean;
  rewarded: boolean;
}

export interface ReferralCodeData {
  referralCode: string;
  referralLink: string;
  currentSignups: number;
  milestones: ReferralMilestone[];
  nextMilestone: { target: number; remaining: number } | null;
  allMilestonesReached: boolean;
}

export interface ReferralReferee {
  name: string;
  joinedAt: string;
}

export interface ReferralStatsData extends ReferralCodeData {
  referees: ReferralReferee[];
  boostCreditsEarned: number;
  boostCreditsAvailable: number;
}

export interface ReferralValidation {
  valid: boolean;
  referrerFirstName: string;
}

const referralService = {
  async getOrCreateCode(): Promise<ReferralCodeData> {
    const res = await apiClient.request<ReferralCodeData>(
      '/api/v1/referrals/my-code'
    );
    return res.data!;
  },

  async getStats(): Promise<ReferralStatsData> {
    const res = await apiClient.request<ReferralStatsData>(
      '/api/v1/referrals/stats'
    );
    return res.data!;
  },

  async validateCode(code: string): Promise<ReferralValidation> {
    const res = await apiClient.request<ReferralValidation>(
      `/api/v1/referrals/validate/${encodeURIComponent(code)}`,
      { skipAuth: true }
    );
    return res.data!;
  },
};

export default referralService;
